import firebase from '../store/api/fbConfig';

export const getFirestore = () => firebase.firestore();
export const reduxFirestore = () => next => next;
export const firestoreReducer = (state = {}) => state;
export const createFirestoreInstance = () => firebase.firestore();
export default getFirestore;
